import React, { useEffect, useState } from 'react';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useGetMyEduCourseDatesQuery } from '../../../../../../redux/services/eduCourseDates.jsx';
import { useCourseDateEnrollMutations } from '../../../../../../hooks/useCourseDateEnrollMutations.jsx';
import { useSelector } from 'react-redux';
import MyEduCourseDatesTable from './MyEduCourseDatesTable.jsx';
import useUserHasRole from '../../../../../../hooks/useUserHasRoles.jsx';
import { ROLE_FRI_EDU_PATRICIPANT } from '../../../../../../utils/constants/roles.js';
import { routes as appRoutes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useNavigate } from 'react-router-dom';

export const MyEduCourseDatesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: dates, isLoading, refetch } = useGetMyEduCourseDatesQuery();
  const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);
  const hasParticipantRole = useUserHasRole(ROLE_FRI_EDU_PATRICIPANT);

  const [pendingOpenDateId, setPendingOpenDateId] = useState(undefined);
  const [autoEnrollDone, setAutoEnrollDone] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('edu-open-date-id');
      const id = raw ? parseInt(raw, 10) : undefined;
      if (id) setPendingOpenDateId(id);
      localStorage.removeItem('edu-open-date-id');
    } catch {}
  }, []);

  const { enrollToCourseDate, unenrollFromCourseDate } =
    useCourseDateEnrollMutations({
      onEnrollmentChange: () => {
        refetch?.();
      },
    });

  useEffect(() => {
    if (!pendingOpenDateId || !isLoggedIn || autoEnrollDone) return;
    enrollToCourseDate(pendingOpenDateId);
    setAutoEnrollDone(true);
  }, [pendingOpenDateId, isLoggedIn, autoEnrollDone]);

  useEffect(() => {
    document.title = `FRI.edu - ${t('Moje termíny')}`;
  }, [t]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Moje termíny')}
        backUrl={routes.cmsDashboard}
        permissionsBasic={'fri-edu-course-dates'}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock
          collapsible
          title={t('Termíny, na ktoré som prihlásený')}
        >
          <MyEduCourseDatesTable
            datesData={dates}
            isLoggedIn={isLoggedIn}
            hasParticipantRole={hasParticipantRole}
            onEnroll={(dateId) => enrollToCourseDate(dateId)}
            onUnenroll={({ dateId, participantId }) =>
              unenrollFromCourseDate({ dateId, participantId })
            }
            onRequireAuth={(row) => {
              try {
                localStorage.setItem('edu-open-date-id', String(row?.id));
              } catch {}
              window.location.assign(appRoutes.cmsEduMyDates);
            }}
            onShowCourseDetail={(courseId) =>
              navigate(`${routes.cmsCourseDetail}/${courseId}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default MyEduCourseDatesPage;
